import { Grid } from '@mui/material';
import { WaitingLineType } from 'lib/graphql/graphql';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

import WaitingLineTypeCard from './components/WaitingLineTypeCard';
import {
  free,
  gold,
  silver,
} from './lib/waitingLineData';
import { FullHeightGrid } from './styles';

const waitingLinesData = Object.values({
  free,
  silver,
  gold,
});

type SelectWaitingLineTypeProps = {
  changeFormPage: (page: number) => void;
};

function SelectWaitingLineType(props: SelectWaitingLineTypeProps) {
  const { changeFormPage } = props;
  const { register, setValue } = useFormContext();

  register('waitingLineType', { required: 'required' });

  const handleSelect = useCallback((waitingLineType: WaitingLineType) => {
    setValue('waitingLineType', waitingLineType);
    changeFormPage(1);
  }, [changeFormPage, setValue]);

  return (
    <FullHeightGrid container direction="row" justifyContent="space-around" rowGap={2}>
      {waitingLinesData.map((waitingLine) => (
        <Grid
          key={waitingLine.waitingLineType}
          item
          xl={4}
          lg={6}
          padding={1}
        >
          <WaitingLineTypeCard
            titleId={waitingLine.title}
            waitingLineDescriptionIds={waitingLine.descriptions}
            waitingLineType={waitingLine.waitingLineType}
            handleSelect={handleSelect}
          />
        </Grid>
      ))}
    </FullHeightGrid>
  );
}

export default SelectWaitingLineType;
